import React from 'react'
import Link from 'next/link'
import {
    getSearchResultDisplayPrice,
    getSearchResultFilterKey,
} from '@/components/Refresh/SearchResults/searchResultsUtils'
import { getServiceHref as getSkuPageHref } from '@/lib/getServiceHref'
import {
    STORE_DISPLAY_PRICE_SUBTEXT,
    STORE_DISPLAY_PRICE_UNAVAILABLE_LABEL,
} from '@/lib/store/storeDisplayPricing'
import type { ServiceItem } from '@/types/interfaces/service-item'
import ProductImage from './ProductImage'
import classes from './Product.module.css'

export interface ProductProps {
    service: ServiceItem
    getServiceHref?: (service: ServiceItem) => string | undefined
}

export default function Product({ service, getServiceHref = getSkuPageHref }: ProductProps) {
    const href = getServiceHref(service)
    const pricedDisplay = getSearchResultDisplayPrice(service)
    const displayPrice =
        pricedDisplay ||
        (getSearchResultFilterKey(service) === 'medications' ? STORE_DISPLAY_PRICE_UNAVAILABLE_LABEL : '')

    const content = (
        <>
            <ProductImage service={service} />
            <div className={classes.text}>
                <div className={classes.title}>{service.title}</div>
                {displayPrice !== '' ? (
                    <div className={classes.priceBlock}>
                        <div className={classes.price}>{displayPrice}</div>
                        <div className={classes.priceSubtext}>{STORE_DISPLAY_PRICE_SUBTEXT}</div>
                    </div>
                ) : null}
            </div>
        </>
    )

    if (href == null) {
        return <div className={classes.product}>{content}</div>
    }

    return (
        <Link href={href} prefetch={false} className={classes.product}>
            {content}
        </Link>
    )
}
